
export default function WhyUs() {
  const advantages = [
    {
      icon: 'ri-360-line',
      title: '360° Hizmet Anlayışı',
      description: 'Yatırım fikrinden ihracat aşamasına kadar işletmenizin tüm süreçlerinde yanınızdayız. Tek muhatap, tam çözüm.'
    },
    {
      icon: 'ri-book-open-line',
      title: 'Mevzuat Uzmanlığı',
      description: 'Sanayi sicilden teşviklere, kapasite raporundan ÇED süreçlerine tüm yasal gerekliliklere tam hakimiyet.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Vizyon',
      description: 'CE, EAC, SABER ve TSE ile ürünlerinizi Avrupa, Avrasya ve Orta Doğu pazarlarına açıyoruz.'
    },
    {
      icon: 'ri-code-box-line',
      title: 'Dijital Dönüşüm',
      description: 'Özel yazılım çözümlerimizle süreçlerinizi otomatize ediyor, verimliliğinizi artırıyoruz.'
    }
  ];

  return (
    <section id="neden-biz" className="py-24 bg-[#F8F9FA] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-5xl lg:text-6xl font-bold text-[#2D3436] mb-6 tracking-tight">
              Neden KGM Danışmanlık?
            </h2>
            <p className="text-lg text-gray-600 mb-10 leading-relaxed">
              Endüstriyel süreçlerinizin her aşamasında güvenilir, deneyimli ve çözüm odaklı bir iş ortağı.
            </p>

            {/* Advantage Cards */}
            <div className="space-y-6">
              {advantages.map((advantage, index) => (
                <div
                  key={index}
                  className="group bg-white rounded-xl p-6 shadow-[0_2px_15px_rgba(0,0,0,0.06)] hover:shadow-[0_8px_25px_rgba(193,127,89,0.12)] transition-all duration-300 border border-gray-100 hover:border-[#C17F59]/30 cursor-pointer"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-lg bg-[#C17F59]/10 flex items-center justify-center flex-shrink-0 group-hover:bg-[#C17F59] transition-all duration-300">
                      <i className={`${advantage.icon} text-2xl text-[#C17F59] group-hover:text-white transition-all duration-300`}></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-[#2D3436] mb-2">
                        {advantage.title}
                      </h3>
                      <p className="text-sm text-gray-600 leading-relaxed">
                        {advantage.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/4af303baad863f31fb42ccc1ae8fe8cd.jpg"
                alt="KGM Danışmanlık Ekibi"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2D3436]/60 to-transparent"></div>
              
              {/* Overlay Stats */}
              <div className="absolute bottom-8 left-8 right-8">
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-white/95 backdrop-blur-sm rounded-lg p-4">
                    <div className="text-3xl font-bold text-[#C17F59] mb-1">10+</div>
                    <div className="text-xs text-gray-700 font-semibold">Yıl Deneyim</div>
                  </div>
                  <div className="bg-white/95 backdrop-blur-sm rounded-lg p-4">
                    <div className="text-3xl font-bold text-[#C17F59] mb-1">200+</div>
                    <div className="text-xs text-gray-700 font-semibold">Tamamlanan Proje</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating Certification Badges */}
            <div className="absolute -top-6 -right-6 bg-white rounded-xl p-4 shadow-xl border border-gray-100">
              <img
                src="https://readdy.ai/api/search-image?query=TURKAK%20accreditation%20badge%20with%20ISO%20certification%20symbols%2C%20professional%20quality%20assurance%20emblem%2C%20clean%20modern%20design&width=120&height=120&seq=turkak-badge&orientation=squarish"
                alt="TÜRKAK Akreditasyonu"
                className="w-20 h-20 object-contain"
              />
            </div>
          </div>
        </div>

        {/* Bottom Highlight Section */}
        <div className="mt-20 bg-gradient-to-r from-[#2D3436] to-[#3D4446] rounded-2xl p-12 text-center relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-0 w-full h-full" style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23FFFFFF' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            }}></div>
          </div>
          
          <div className="relative">
            <h3 className="text-3xl lg:text-4xl font-bold text-white mb-4">
              Tek Muhatap, Tam Çözüm
            </h3>
            <p className="text-lg text-gray-300 mb-8 max-w-3xl mx-auto">
              Yazılım, belgelendirme, kalibrasyon ve ihracat süreçlerinizi tek bir güvenilir kaynaktan yönetin. Zaman ve maliyet tasarrufu sağlayın.
            </p>
            <a
              href="#iletisim"
              className="inline-flex items-center bg-[#C17F59] text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-[#A66B47] transition-all hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              <span>Hemen Başlayın</span>
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
